export default __webpack_public_path__ + "static/media/loyola1.4b6bd1f4.jpg";